import { render } from "./HomeSimp.vue?vue&type=template&id=7c44f2c0"
import script from "./HomeSimp.vue?vue&type=script&lang=js"
export * from "./HomeSimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__